module.exports = __webpack_public_path__ + "static/img/1-5.1ab1d79b.png";